import React from "react";

import "./container.styles.scss";
interface ContainerProps {
  children: any;
}

const Container = ({ children }: ContainerProps) => (
  <div className="InventoryTool-container">{children}</div>
);

export default Container;
